module.exports = __webpack_public_path__ + "static/media/calendarIcon.226ecf6f.svg";